import { NSNavigationReact } from "./lib/nsNavigation/nsNavigationReact";

export {DynamicComponentService} from "./lib/dynamicComponentService/dynamicComponentService";

/* NSAjax */
export {NSAjaxReact} from "./lib/nsAjax/nsAjaxReact";

/* NSCalendar */
export {NSCalendarReact} from "./lib/nsCalendar/nsCalendarReact";
export {INSCalendarReactSetting} from "./lib/nsCalendar/nsCalendarReact";
export {INSCalendarMarkDayDisabledFunction} from "./lib/nsCalendar/interfaces";
export {INSCalendarButtonSettingObject} from "./lib/nsCalendar/interfaces";
export {INSCalendarButtonSetting} from "./lib/nsCalendar/interfaces";
export {INSCalendarCustomClass} from "./lib/nsCalendar/interfaces";
export {INSCalendarSetting} from "./lib/nsCalendar/interfaces";

/* NSDatePicker */
export {NSDatePickerReact} from "./lib/nsDatePicker/nsDatePickerReact";
export {INSDatePickerReactSetting} from "./lib/nsDatePicker/nsDatePickerReact";
export {INSDatePickerCustomClass} from "./lib/nsDatePicker/interfaces";
export {INSDatePickerSetting} from "./lib/nsDatePicker/interfaces";

/* NSGrid */
export {NSGridReact} from "./lib/nsGrid/nsGridReact";
export {INSGridReactSettings} from "./lib/nsGrid/nsGridReact";
export {INSGridCascadeFunction} from "./lib/nsGrid/interfaces";
export {INSGridFilterRendererFunction} from "./lib/nsGrid/interfaces";
export {INSGridAdvancedFilterHandler} from "./lib/nsGrid/interfaces";
export {INSGridGroupRendererFunction} from "./lib/nsGrid/interfaces";
export {INSGridItemRendererFunction} from "./lib/nsGrid/interfaces";
export {INSGridLabelFunction} from "./lib/nsGrid/interfaces";
export {INSGridToolTipRendererFunction} from "./lib/nsGrid/interfaces";
export {INSGridTemplateSetDataFunction} from "./lib/nsGrid/interfaces";
export {INSGridHeaderRendererFunction} from "./lib/nsGrid/interfaces";
export {INSGridExtraRowHeaderRendererFunction} from "./lib/nsGrid/interfaces";
export {INSGridContextMenuProviderFunction} from "./lib/nsGrid/interfaces";
export {INSGridPaginationFetchRecordFunction} from "./lib/nsGrid/interfaces";
export {INSGridFilterFunction} from "./lib/nsGrid/interfaces";
export {INSGridHierarchyFilterChildrenFunction} from "./lib/nsGrid/interfaces";
export {INSGridRowMoverDropEndHandlerFunction} from "./lib/nsGrid/interfaces";
export {INSGridEditorValidatorFunction} from "./lib/nsGrid/interfaces";
export {INSGridEditorIsCellEditableFunction} from "./lib/nsGrid/interfaces";
export {INSGridEditorAPICommitChangesFunction} from "./lib/nsGrid/interfaces";
export {INSGridEditorAPICancelChangesFunction} from "./lib/nsGrid/interfaces";
export {INSGridOnDemandChildFetchCallbackFunction} from "./lib/nsGrid/interfaces";
export {INSEventDispatcherFunction} from "./lib/nsGrid/interfaces";
export {INSGridCustomClassSetting} from "./lib/nsGrid/interfaces";
export {INSGridMultiCellSelectionSetting} from "./lib/nsGrid/interfaces";
export {INSGridFilterSetting} from "./lib/nsGrid/interfaces";
export {INSGridColumnCustomIcon} from "./lib/nsGrid/interfaces";
export {INSGridEditorSetting} from "./lib/nsGrid/interfaces";
export {INSGridColumnEditorSetting} from "./lib/nsGrid/interfaces";
export {INSGridEditorCustomComponentSetting} from "./lib/nsGrid/interfaces";
export {INSGridRendererComponentInstance} from "./lib/nsGrid/interfaces";
export {INSGridRendererComponent} from "./lib/nsGrid/interfaces";
export {INSGridGroupRendererComponentInstance} from "./lib/nsGrid/interfaces";
export {INSGridGroupRendererComponent} from "./lib/nsGrid/interfaces";
export {INSGridHeaderRendererComponentInstance} from "./lib/nsGrid/interfaces";
export {INSGridToolTipRendererComponentInstance} from "./lib/nsGrid/interfaces";
export {INSGridToolTipRendererComponent} from "./lib/nsGrid/interfaces";
export {INSGridExtraRowHeaderRendererComponentInstance} from "./lib/nsGrid/interfaces";
export {INSGridExtraRowHeaderRendererComponent} from "./lib/nsGrid/interfaces";
export {INSGridEditorCustomComponentInstance} from "./lib/nsGrid/interfaces";
export {INSGridEditorCustomComponent} from "./lib/nsGrid/interfaces";
export {INSGridColumn} from "./lib/nsGrid/interfaces";
export {INSGridSetting} from "./lib/nsGrid/interfaces";
export {INSGridMasterDetailSetting} from "./lib/nsGrid/interfaces";
export {INSGridDetailRendererComponent} from "./lib/nsGrid/interfaces";
export {INSGridDetailRendererComponentParam} from "./lib/nsGrid/interfaces";
/* NSMessageBox */
export {NSMessageBoxReact} from "./lib/nsMessageBox/nsMessageBoxReact";
export {INSMessageBoxReactSettings} from "./lib/nsMessageBox/nsMessageBoxReact";
export {INSMessageBoxCallbackFunction} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxConfirmButtonSetting} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxToolBarDetails} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxBodyComponent} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxSetting} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxAlertSetting} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxConfirmSetting} from "./lib/nsMessageBox/interfaces";
export {INSMessageBoxCustomSetting} from "./lib/nsMessageBox/interfaces";

/* NSMultiselectDropdown */
export {NSMultiselectDropdownReact} from "./lib/nsMultiselectdropdown/nsMultiselectDropdownReact";
export {INSMultiSelectDropdownReactSetting} from "./lib/nsMultiselectdropdown/nsMultiselectDropdownReact";
export {INSMultiSelectDropdownSelectedCallback} from "./lib/nsMultiselectdropdown/interfaces";
export {INSMultiSelectDropdownDisabledCallback} from "./lib/nsMultiselectdropdown/interfaces";
export {INSMultiSelectDropdownLabelRenderer} from "./lib/nsMultiselectdropdown/interfaces";
export {INSMultiSelectDropdownFilterSetting} from "./lib/nsMultiselectdropdown/interfaces";
export {INSMultiSelectDropdownSetting} from "./lib/nsMultiselectdropdown/interfaces";

/* NSNavigation */
export {NSNavigationReact} from "./lib/nsNavigation/nsNavigationReact";
export {INSNavigationReactRef} from "./lib/nsNavigation/nsNavigationReact";
export {INSNavigationReactSettings} from "./lib/nsNavigation/nsNavigationReact";
export {INSNavigationClickFunction} from "./lib/nsNavigation/interfaces";
export {INSNavigationMenu} from "./lib/nsNavigation/interfaces";
export {INSNavigationCustomClassSetting} from "./lib/nsNavigation/interfaces";
export {INSNavigationSetting} from "./lib/nsNavigation/interfaces";

/* NSHorizontalNavigation */
export { NSHorizontalNavigationReact } from "./lib/nsHorizontalNavigation/nsHorizontalNavigation";
export { INSHorizontalNavigationReactRef } from "./lib/nsHorizontalNavigation/nsHorizontalNavigation";
export { INSHorizontalNavigationReactSettings } from "./lib/nsHorizontalNavigation/nsHorizontalNavigation";
export { INSHorizontalNavigationClickFunction } from "./lib/nsHorizontalNavigation/interfaces";
export { INSHorizontalNavigationMenu } from "./lib/nsHorizontalNavigation/interfaces";
export { INSHorizontalNavigationCustomClassSetting } from "./lib/nsHorizontalNavigation/interfaces";
export { INSHorizontalNavigationSetting } from "./lib/nsHorizontalNavigation/interfaces";

/* NSPanel */
export {NSPanelReact} from "./lib/nsPanel/nsPanelReact";
export {INSPanelReactSettings} from "./lib/nsPanel/nsPanelReact";
export {INSPanelMinimizeAddRemoveElementFunction} from "./lib/nsPanel/interfaces";
export {INSPanelCustomClass} from "./lib/nsPanel/interfaces";
export {INSPanelToolBarDetailsObject} from "./lib/nsPanel/interfaces";
export {INSPanelToolBarDetails} from "./lib/nsPanel/interfaces";
export {INSPanelDivSetting} from "./lib/nsPanel/interfaces";
export {INSPanelSetting} from "./lib/nsPanel/interfaces";

/* NSTabNavigator */
export {NSTabNavigatorReact} from "./lib/nsTabNavigator/nsTabNavigatorReact";
export {INSTabNavigatorReactSetting} from "./lib/nsTabNavigator/nsTabNavigatorReact";
export {INSTabNavigatorSetting} from "./lib/nsTabNavigator/interfaces";

/* NSTextBox*/
export {NSTextBoxReact} from "./lib/nsTextBox/nsTextBoxReact";
export {INSTextBoxReactSetting} from "./lib/nsTextBox/nsTextBoxReact";
export {INSTextBoxServerSearchFunction} from "./lib/nsTextBox/interfaces";
export {INSTextBoxRendererFunction} from "./lib/nsTextBox/interfaces";
export {INSTextBoxSetting} from "./lib/nsTextBox/interfaces";

/* NSDashboard*/
export {NSDashboardReact} from "./lib/nsDashboard/nsDashboardReact";
export {INSDashboardReactSettings} from "./lib/nsDashboard/nsDashboardReact";
export {INSDashboardBodyComponent} from "./lib/nsDashboard/interfaces";
export {INSDashboardPanelSetting} from "./lib/nsDashboard/interfaces";
export {INSDashboardSetting} from "./lib/nsDashboard/interfaces";

/* NSEditor*/
export {NSEditorReact} from "./lib/nsEditor/nsEditorReact";
export {INSEditorReactSetting} from "./lib/nsEditor/nsEditorReact";
export {INSEditorSetting} from "./lib/nsEditor/interfaces";

interface IJSType {
    [propName: string]: any;
}

const nsCompAjax: IJSType = require('./generated/js/nsAjax.min.js');
export const NSAjax = nsCompAjax.NSAjax;
export type NSAjaxType = ReturnType<typeof nsCompAjax.NSAjax>;

const nsCompConsole: IJSType = require('./generated/js/nsConsole.min.js');
export const NSConsole = nsCompConsole.NSConsole;
export type NSConsoleType = ReturnType<typeof nsCompConsole.NSConsole>;

const nsCompContainerBase: IJSType = require('./generated/js/nsContainerBase.min.js');
export const NSContainerBase = nsCompContainerBase.NSContainerBase;
export type NSContainerBaseType = ReturnType<typeof nsCompContainerBase.NSContainerBase>;

const nsCompDashboard: IJSType = require('./generated/js/nsDashboard.min.js');
export const NSDashboard = nsCompDashboard.NSDashboard;
export type NSDashboardType = ReturnType<typeof nsCompDashboard.NSDashboard>;

const nsCompDateUtil = require('./generated/js/nsDateUtil.min.js');
export const NSDateUtil = nsCompDateUtil.NSDateUtil;
export type NSDateUtilType = ReturnType<typeof nsCompDateUtil.NSDateUtil>;

const nsCompDatePicker = require('./generated/js/nsDatePicker.min.js');
export const NSCalendar = nsCompDatePicker.NSCalendar;
export type NSCalendarType = ReturnType<typeof nsCompDatePicker.NSCalendar>;
export const NSDatePicker = nsCompDatePicker.NSDatePicker;
export type NSDatePickerType = ReturnType<typeof nsCompDatePicker.NSDatePicker>;

const nsCompDividerBox = require('./generated/js/nsDividerBox.min.js');
export const NSDividerBox = nsCompDividerBox.NSDividerBox;
export type NSDividerBoxType = ReturnType<typeof nsCompDividerBox.NSDividerBox>;

/*const nsCompDocxExport = require('./generated/js/nsDocxExport.min.js');
export const NSDocxExport = nsCompDocxExport.NSDocxExport;
export type NSDocxExportType = ReturnType<typeof nsCompDocxExport.NSDocxExport>;*/

const nsCompEditor = require('./generated/js/nsEditor.min.js');
export const NSEditor = nsCompEditor.NSEditor;
export type NSEditorType = ReturnType<typeof nsCompEditor.NSEditor>;

const nsCompEvent: IJSType = require('./generated/js/nsEvent.min.js');
export const NSEvent = nsCompEvent.NSEvent;
export type NSEventType = ReturnType<typeof nsCompEvent.NSEvent>;

const nsCompExport = require('./generated/js/nsExport.min.js');
export const NSExport = nsCompExport.NSExport;
export type NSExportType = ReturnType<typeof nsCompExport.NSEditor>;

const nsCompGrid = require('./generated/js/nsGrid.min.js');
export const NSGrid = nsCompGrid.NSGrid;
export type NSGridType = ReturnType<typeof nsCompGrid.NSGrid>;

const nsCompList = require('./generated/js/nsList.min.js');
export const NSList = nsCompList.NSList;
export type NSListType = ReturnType<typeof nsCompList.NSList>;

const nsCompMessageBox = require('./generated/js/nsMessageBox.min.js');
export const NSMessageBox = nsCompMessageBox.NSMessageBox;
export type NSMessageBoxType = ReturnType<typeof nsCompMessageBox.NSMessageBox>;
export const NSPanel = nsCompMessageBox.NSPanel;
export type NSPanelType = ReturnType<typeof nsCompMessageBox.NSPanel>;

const nsCompMultiSelectDropdown = require('./generated/js/nsMultiSelectDropdown.min.js');
export const NSMultiSelectDropdown = nsCompMultiSelectDropdown.NSMultiSelectDropdown;
export type NSMultiSelectDropdownType = ReturnType<typeof nsCompMultiSelectDropdown.NSMultiSelectDropdown>;

const nsCompNavigation = require('./generated/js/nsNavigation.min.js');
export const NSNavigation = nsCompNavigation.NSNavigation;
export type NSNavigationType = ReturnType<typeof nsCompNavigation.NSNavigation>;

const nsCompHorizontalNavigation = require('./generated/js/nsHorizontalNavigation.min.js');
export const NSHorizontalNavigation = nsCompHorizontalNavigation.NSHorizontalNavigation;
export type NSHorizontalNavigationType = ReturnType<typeof nsCompHorizontalNavigation.NSHorizontalNavigation>;

const nsCompNumericTextBox = require('./generated/js/nsNumericTextBox.min.js');
export const NSNumericTextBox = nsCompNumericTextBox.NSNumericTextBox;
export type NSNumericTextBoxType = ReturnType<typeof nsCompNumericTextBox.NSNumericTextBox>;

const nsCompPagination = require('./generated/js/nsPagination.min.js');
export const NSPagination = nsCompPagination.NSPagination;
export type NSPaginationType = ReturnType<typeof nsCompPagination.NSPagination>;

const nsCompPinTip = require('./generated/js/nsPinTip.min.js');
export const NSPinTip = nsCompPinTip.NSPinTip;
export type NSPinTipType = ReturnType<typeof nsCompPinTip.NSPinTip>;

//js file is wrong
/*const nsCompProgressBar = require('./generated/js/nsProgressBar.min.js');
export const NSProgressBar = nsCompProgressBar.NSProgressBar;
export type NSProgressBarType = ReturnType<typeof nsCompProgressBar.NSProgressBar>;*/

const nsCompRouter = require('./generated/js/nsRouter.min.js');
export const NSRouter = nsCompRouter.NSRouter;
export type NSRouterType = ReturnType<typeof nsCompRouter.NSRouter>;

const nsCompScroller = require('./generated/js/nsScroller.min.js');
export const NSScroller = nsCompScroller.NSScroller;
export type NSScrollerType = ReturnType<typeof nsCompScroller.NSScroller>;

const nsCompSVG = require('./generated/js/nsSVG.min.js');
export const NSSvg = nsCompSVG.NSSvg;
export type NSSvgType = ReturnType<typeof nsCompSVG.NSSvg>;
export const NSSvgShapes = nsCompSVG.NSSvgShapes;
export type NSSvgShapesType = ReturnType<typeof nsCompSVG.NSSvgShapes>;

const nsCompTableRowMover = require('./generated/js/nsTableRowMover.min.js');
export const NSTableRowMover = nsCompTableRowMover.NSTableRowMover;
export type NSTableRowMoverType = ReturnType<typeof nsCompTableRowMover.NSTableRowMover>;

const nsCompTabNavigator = require('./generated/js/nsTabNavigator.min.js');
export const NSTabNavigator = nsCompTabNavigator.NSTabNavigator;
export type NSTabNavigatorType = ReturnType<typeof nsCompTabNavigator.NSTabNavigator>;

const nsCompTextBox = require('./generated/js/nsTextBox.min.js');
export const NSTextBox = nsCompTextBox.NSTextBox;
export type NSTextBoxType = ReturnType<typeof nsCompTextBox.NSTextBox>;

const nsCompTouchToMouse = require('./generated/js/nsTouchToMouse.min.js');
export const NSTouchToMouse = nsCompTouchToMouse.NSTouchToMouse;
export type NSTouchToMouseType = ReturnType<typeof nsCompTouchToMouse.NSTouchToMouse>;

const nsCompUtil = require('./generated/js/nsUtil.min.js');
export const NSUtil = nsCompUtil.NSUtil;
export type NSUtilType = ReturnType<typeof nsCompUtil.NSUtil>;

const nsCompVirtualScroll = require('./generated/js/nsVirtualScroll.min.js');
export const NSVirtualScroll = nsCompVirtualScroll.NSVirtualScroll;
export type NSVirtualScrollType = ReturnType<typeof nsCompVirtualScroll.NSVirtualScroll>;

const nsCompXlsxExport = require('./generated/js/nsXlsxExport.min.js');
export const NSXlsxExport = nsCompXlsxExport.NSXlsxExport;
export type NSXlsxExportType = ReturnType<typeof nsCompXlsxExport.NSXlsxExport>;

const nsCompExpressionEvaluator = require('./generated/js/nsExpressionEvaluator.min.js');
export const NSExpressionEvaluator = nsCompExpressionEvaluator.NSExpressionEvaluator;
export type NSExpressionEvaluatorType = ReturnType<typeof nsCompExpressionEvaluator.NSExpressionEvaluator>;










